'use client'

import { useTranslate } from '@repo/shared/hooks'
import {
  Button,
  Modal,
  ModalContent,
  ModalTrigger,
  Icon,
  Row,
  Typography,
} from '@repo/ui/components'
import { ButtonLink, KycBlocker } from '@repo/shared/components'
import { useAgentAuthDetails } from '@repo/services'
import { ShebaInput } from './sheba-input.component'

export const ShebasCTA = ({
  origin,
  showAddCard = true,
}: {
  origin: 'layout' | 'container'
  showAddCard?: boolean
}) => {
  const { t } = useTranslate()
  const { data: authDetails } = useAgentAuthDetails()
  const hasKyc =
    authDetails?.data.details?.kyc &&
    authDetails?.data.details?.kyc?.status === 'approved'

  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light p-xs md:p-0 gap-xs justify-between`}
    >
      <Row className='w-fit'>
        {origin === 'layout' && (
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/profile'
            aria-label='Back to Profile'
            endIcon={<Icon name='ArrowRightLine' size='md' />}
          />
        )}
        {/* <Typography size='md' weight='bold'>
          {t('cardsPage_title')}
        </Typography> */}
      </Row>
      {showAddCard && (
        <Row className='w-fit'>
          <Modal>
            <ModalTrigger asChild>
              <Button
                variant={origin === 'layout' ? 'transparent' : 'fill'}
                size='xs'
                color='base'
                startIcon={
                  <Icon name='PlusLine' size='xs' color='fill-current' />
                }
              >
                {t('cardsPage_button')}
              </Button>
            </ModalTrigger>
            <ModalContent className='sm:max-w-[425px]'>
              {hasKyc ? (
                <ShebaInput />
              ) : (
                <KycBlocker
                  phone={authDetails?.data.phone}
                  email={authDetails?.data.email}
                  kyc={authDetails?.data.details?.kyc}
                />
              )}
            </ModalContent>
          </Modal>
        </Row>
      )}
    </Row>
  )
}
